// @ts-nocheck
/* eslint-disable */

"use client";

import {
  BlogCard,
  Button,
  Column,
  Heading,
  IconTitle,
  ImageWrapper,
  RichText,
  Row,
  Spacer,
} from "tempdev-ds";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import Link from "next/link";
import { formatDate } from "@/lib/helpers/dateFormate";
import { useGlobalContext } from "@/lib/globalContext";

const AuthorsPost = (post: Record<string, unknown>) => {
  const state = useGlobalContext();

  return (
    <div>
      <Spacer height={6} />

      <Row align="center" mobileSpace={true}>
        <Column md={5} mobileOrder={2}>
          <Heading
            size="texts"
            tag="span"
            className="color-gray50 text-uppercase fw-semibold"
          >
            {post?.acf?.role}
          </Heading>
          <Heading size="h1" tag="h1" className="mb-3">
            {post.name}
          </Heading>
          <RichText tag="p" className="mb-3">
            {post.description}
          </RichText>
          <div>
            {post?.acf?.email && (
              <IconTitle
                imageElement={
                  <DisplayImage
                    url={"/assets/components/team-email.svg"}
                    alt={"Email"}
                    width={25}
                    height={25}
                  />
                }
                className="mt-3 me-4"
              >
                <Heading size="texts" tag="h4">
                  <Button variant="link" href={`mailto:${post?.acf?.email}`}>{state?.dict?.custom?.emailMe}</Button>
                </Heading>
              </IconTitle>
            )}
            {post?.acf?.linkedin && (
              <IconTitle
                imageElement={
                  <DisplayImage
                    url={"/assets/components/team-social.svg"}
                    alt={"Linkedin profile"}
                    width={25}
                    height={25}
                  />
                }
                className="mt-3 me-4"
              >
                <Heading size="captions" tag="h4">
                  <Button
                    variant="link"
                    href={post?.acf?.linkedin}
                    target="_blank"
                  >{state?.dict?.custom?.viewProfile}</Button>
                </Heading>
              </IconTitle>
            )}
          </div>
        </Column>
        <Column md={2}></Column>
        <Column md={5} mobileOrder={1}>
          <ImageWrapper aspectRatioHeight={100}>
            <DisplayImage
              url={post?.acf?.profile_image as string}
              alt={post?.name ? (post?.name as string) : ""}
              fill={true}
            />
          </ImageWrapper>
        </Column>
      </Row>
      {post.articles && (
        <>
          <Spacer height={6} />
          <Row>
            <Column md={12}>
              <Heading size="h4" tag="h3" className="mb-4">
                Latest posts by <span class="color-primary70">{post.name}</span>
              </Heading>
            </Column>
            {post.articles.map((item: Record<string, unknown>, i: number) => {
              const author = item?.author
                ? {
                    ...item?.author,
                    imageElement: (
                      <DisplayImage
                        url={item?.author?.img as string}
                        alt={
                          item?.author?.name
                            ? (item?.author?.name as string)
                            : ""
                        }
                        fill={true}
                      />
                    ),
                  }
                : {};

              return (
                <Column key={`blogCard-${i}`} sm={12} md={6}>
                  <BlogCard
                    variant={"md"}
                    date={formatDate(item?.date as string, 'DATE_SHORT')}
                    imageElement={
                      <DisplayImage
                        url={item?.image as string}
                        alt={item?.title ? (item?.title as string) : ""}
                        fill={true}
                      />
                    }
                    title={item?.title}
                    description={item?.excerpt}
                    author={author}
                    linkElement={
                      <Link
                        href={item?.slug as string}
                        className="linker"
                      ></Link>
                    }
                  />
                </Column>
              );
            })}
          </Row>
        </>
      )}
      <Spacer height={8} />
    </div>
  );
};
export default AuthorsPost;
